import { render, staticRenderFns } from "./navigation-client-menu.vue?vue&type=template&id=7596cfae&scoped=true&"
import script from "./navigation-client-menu.vue?vue&type=script&lang=ts&"
export * from "./navigation-client-menu.vue?vue&type=script&lang=ts&"
import style0 from "./navigation-client-menu.vue?vue&type=style&index=0&id=7596cfae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7596cfae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VDivider,VIcon,VList,VListItem,VListItemGroup,VListItemTitle,VMenu})
